import type { PreferencesSection } from './types';

// Applies the proposed order to non-locked sections, then re-pins each locked
// section to its original index. Locked items are re-inserted in ascending
// original-index order so earlier pins shift later ones rightward consistently.
export const reorderSections = (
  sections: PreferencesSection[],
  newOrder: (string | number)[]
): PreferencesSection[] => {
  const byId = new Map(sections.map((s) => [s.id, s]));

  const result = newOrder.reduce<PreferencesSection[]>((acc, id) => {
    const section = byId.get(String(id));
    if (section && !section.locked) {
      acc.push(section);
    }

    return acc;
  }, []);

  sections.forEach((section, originalIndex) => {
    if (section.locked) {
      result.splice(originalIndex, 0, section);
    }
  });

  return result;
};

export const toggleSectionEnabled = (
  sections: PreferencesSection[],
  sectionId: string,
  enabled: boolean
): PreferencesSection[] =>
  sections.map((s) => (s.id === sectionId ? { ...s, enabled } : s));
